<template>
  <q-btn
    :icon="isSelected === '1' ? 'mdi-close' : 'mdi-help-circle-outline'"
    :class="'needInquiry ' + setDisableClass()"
    :disabled="isDisable()"
    :label="isSelected === '1' ? '取消' : '問合'"
    @click="quotable"
  >
    <q-popup-proxy v-model="popupFlg" @show="hide">
      <q-banner>
        <template #avatar>
          <q-icon :name="isSelected === '1' ? 'maps_ugc' : 'do_not_disturb_on'" color="primary" />
        </template>
        {{ isSelected === '1' ? '追加されました' : '削除されました' }}
      </q-banner>
    </q-popup-proxy>
  </q-btn>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import OrderQuotableCode from '../../common/code/OrderQuotableCode';

interface Props {
  // 選択フラグ 0:未選択、1:選択済み
  isSelected: string;
  // 注文問合フラグ（注文されてるか、問い合わせされてるか） 0：注文、1:問い合わせ
  orderQuotableFlg: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['quotable']);

const quotable = () => {
  emit('quotable');
};

const isDisable = (): boolean => {
  // 注文済みまたはエラーの場合、true
  if (props.orderQuotableFlg === OrderQuotableCode.ORDER) {
    return true;
  }
  return false;
};

const setDisableClass = (): string => {
  // 注文済みまたはエラーの場合、非活性
  if (props.orderQuotableFlg === OrderQuotableCode.ORDER) {
    return 'disabled';
  }

  // 選択済みの場合、活性
  if (props.isSelected === '1') {
    return 'inactive';
  }

  return '';
};

const popupFlg = ref<boolean>(false);

const sleep = (second: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, second * 1000);
  });

const hide = async () => {
  await sleep(0.5);
  popupFlg.value = false;
};
</script>
